import { useNavigate } from "react-router-dom";
import { useState } from "react";
import LoginForm from "../components/loginForm";
import { createDemoUser } from "../services/demoService";

export default function LoginPage({ onLoginSuccess }) {
  const navigate = useNavigate();
  const [demoLoading, setDemoLoading] = useState(false);
  const [demoError, setDemoError] = useState("");

  const handleDemo = async () => {
    setDemoLoading(true);
    setDemoError("");
    try {
      await createDemoUser();
      navigate("/dashboard?demo=true");
    } catch (err) {
      setDemoError(err.message);
    } finally {
      setDemoLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="auth-left">
        <div className="auth-brand">
          <h1 className="auth-logo">Career Engine</h1>
          <p className="auth-tagline">Land your next job, faster.</p>
        </div>
        <ul className="auth-features">
          <li><span className="auth-check">✓</span> Track every application from first look to offer</li>
          <li><span className="auth-check">✓</span> Optimize your job search through data insights</li>
          <li><span className="auth-check">✓</span> Let AI review your application before you submit</li>
        </ul>
      </div>
      <div className="auth-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Welcome back</h2>
            <p className="login-card-sub">Sign in to your account</p>
          </div>
          <LoginForm
            onLoginSuccess={(userId) => {
              onLoginSuccess?.(userId);
              navigate("/dashboard");
            }}
          />
          <div className="demo-divider">or</div>
          <button className="btn-demo" onClick={handleDemo} disabled={demoLoading}>
            {demoLoading ? "Setting up demo..." : "Try Demo"}
          </button>
          {demoError && <p className="message">{demoError}</p>}
          <div className="register-link">
            <span>Don't have an account?</span>
            <button onClick={() => navigate("/register")}>Register</button>
          </div>
        </div>
      </div>
    </div>
  );
}
